import * as R from "ramda";

const buildKey = keyName =>
  R.pipe(
    R.toString,
    R.concat(`${keyName}`)
  );

const questionKey = buildKey("challengeQuestions");
const answerKey = buildKey("challengeAnswers");

const getAvailableQuestions = ({
  index,
  values,
  questionCount,
  allOptions,
}) => {
  const usedQuestions = R.pipe(
    R.times(questionIndex => {
      const question =
        index === questionIndex
          ? undefined
          : values[questionKey(questionIndex)];
      return question;
    }),
    R.reject(R.isNil)
  )(questionCount);

  const availableQuestions = R.reject(option => {
    return R.contains(option.value, usedQuestions);
  }, allOptions);

  return availableQuestions;
};

const buildChallengeQuestionField = ({
  questionOptions,
  questionCount,
}) => index => props => {
  const availableOptions = getAvailableQuestions({
    index,
    values: props.values,
    questionCount,
    allOptions: questionOptions,
  });

  return {
    type: "section",
    style: {
      mb: 3,
    },
    fields: [
      {
        key: questionKey(index),
        label: `Question #${index + 1}`,
        required: true,
        type: "dropdown",
        inputProps: {
          wrap: true,
          options: availableOptions,
        },
      },
      {
        key: answerKey(index),
        label: "Answer",
        required: true,
        inputProps: {
          autoComplete: "off",
        },
      },
    ],
  };
};

export const buildChallengeQuestionFields = ({
  questionOptions,
  questionCount,
}) => ({ t }) => {
  return R.times(
    buildChallengeQuestionField({ questionOptions, questionCount }),
    questionCount
  );
};

export const getChallengeAnswers = data => index => ({
  key: R.prop(questionKey(index), data),
  value: R.prop(answerKey(index), data),
});



// WEBPACK FOOTER //
// ./src/banking/authentication/challengeQuestionFields.js